<script>
  // Перенос ScrollArea из lib/ui.tsx — золотой тонкий скролл.
  let className = '';
  export { className as class };
  export let style = undefined;
</script>

<div class={'ui-scroll' + (className ? ' ' + className : '')} {style}><slot /></div>
